import { render } from "./Cancer.vue?vue&type=template&id=c09275de&scoped=true"
import script from "./Cancer.vue?vue&type=script&lang=js"
export * from "./Cancer.vue?vue&type=script&lang=js"

import "./Cancer.vue?vue&type=style&index=0&id=c09275de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c09275de"]])

export default __exports__